
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp/[type]",
      function () {
        return require("private-next-pages/lp/[type]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lp/[type]"])
      });
    }
  